// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rating-scale {
  display: flex;
  gap: 0.5em;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/core/RatingScale/index.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,UAAA;ACCJ;AACA,oCAAoC","sourcesContent":[".rating-scale {\n    display: flex;\n    gap: 0.5em;\n}",".rating-scale {\n  display: flex;\n  gap: 0.5em;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
